/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../lib/@waca/dashboard-common/dist/core/Model'], function( Model ) {
	'use strict';

	/**
	 * Model which represents a filter value
	 */
	var FilterValue = null;
	FilterValue = Model.extend({
		whitelistAttrs: ['value'],

		init: function(attrs, options) {
			attrs = (attrs === undefined) ? {} : attrs;
			var filterValueAttrs = {};
			// [OLAPTODO] temporary code to handle filter string value.
			if (attrs && attrs.d) {
				filterValueAttrs.value = {
					d: attrs.d,
					u: attrs.u
				};
			} else if (typeof attrs !== 'object') {
				filterValueAttrs.value = {
					d: attrs,
					u: attrs
				};
			} else {
				filterValueAttrs.value = attrs;
			}

			//For simple values, the id is assigned to match the value
			var id = attrs && attrs.u ? attrs.u : attrs;
			//For compound filters, attrs.value is an object, no id is set in this case.
			if (typeof id !== 'object') {
				filterValueAttrs.id=id;
			}

			FilterValue.inherited('init', this, [filterValueAttrs, options]);
			if (attrs===null) {
				this.id=null;
			}
		}

	});

	return FilterValue;
});
